// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getDocs, collection, doc, getDoc } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)

export const getAllData = async (setAvails, setLadies, setServices, setLoading) => {
    try {
        const querySnapshot = await getDocs(collection(db, "availabilities"));
        const availabilitiesList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        setAvails(availabilitiesList)
    } catch (err) {
        console.error("Error fetching availabilities:", err);
    }

    let ladiesList = []
    try {
        const querySnapshot = await getDocs(collection(db, "ladies"));
        const ladiesList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        setLadies(ladiesList)
    } catch (err) {
        console.error("Error fetching ladies:", err);
    }

    let servicesList = []
    try {
        const querySnapshot = await getDocs(collection(db, "services"));
        const servicesList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        setServices(servicesList)
    } catch (err) {
        console.error("Error fetching ladies:", err);
    }

    setLoading(true)
}

export const getGlobalStyling = async () => {
    try {
        const docRef = doc(db, 'styling', 'global');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        }
        return null;
    } catch (error) {
        console.error("Error fetching global styling:", error);
        return null;
    }
};

